// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


var defaultSortColumn = "transaction_date";

function sortOrderFromQuery(value) {
  if (value === undefined) {
    return "Asc";
  }
  switch (value) {
    case "DESC" :
    case "desc" :
        return "Desc";
    default:
      return "Asc";
  }
}

function sortOrderToQuery(order) {
  if (order === "Asc") {
    return "asc";
  } else {
    return "desc";
  }
}

function sortColumnFromQuery(value, defaultColumnOpt, param) {
  var defaultColumn = defaultColumnOpt !== undefined ? defaultColumnOpt : defaultSortColumn;
  if (value !== undefined && value !== "") {
    return value;
  } else {
    return defaultColumn;
  }
}

function fromQuery(sortColumn, sortOrder, defaultColumnOpt, param) {
  var defaultColumn = defaultColumnOpt !== undefined ? defaultColumnOpt : defaultSortColumn;
  return {
          sortColumn: sortColumnFromQuery(sortColumn, defaultColumn, undefined),
          sortOrder: sortOrderFromQuery(sortOrder)
        };
}

exports.defaultSortColumn = defaultSortColumn;
exports.sortOrderFromQuery = sortOrderFromQuery;
exports.sortOrderToQuery = sortOrderToQuery;
exports.sortColumnFromQuery = sortColumnFromQuery;
exports.fromQuery = fromQuery;
/* No side effect */
